import { memo } from "react";
import { Handle, Position } from "reactflow";

import { AddButton } from "../AddButton/AddButton";
import { useSidebar } from "../../SidebarFlow/context";

const ButtonAddNodeEdge = memo((props) => {
  const { openSidebar } = useSidebar();

  const onEdgeClick = () => {
    openSidebar({
      id: "addNode",
      type: "context_output",
      originType: "responseNode",
      dataNode: props,
    });
  };
  return (
    <>
      <Handle type="target" position={Position.Left} />
      <Handle type="source" position={Position.Right} />
      <AddButton onClick={onEdgeClick} />
    </>
  );
});

export default ButtonAddNodeEdge;
